import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { InvestmentsStoreModule } from './module';

export const InvestmentsModule = getModule(InvestmentsStoreModule, store);
export type {
  IPortfolioInvestmentSummary,
  IPortfolioSaveLastInvestment
} from './module';
